export const convertCoinsToDollars = (balance: number, decimalPlaces = 2) => {
  return (balance * 0.12540293).toFixed(decimalPlaces)
}
